export default "__VITE_ASSET__Cli$fGjW__"